import { action } from 'satcheljs';

export interface MountFullOptionsActionMessage {
    category: string | undefined;
    subcategory: string | undefined;
    option: string | undefined;
}
export const mountFullOptions: (
    category?: string,
    subcategory?: string,
    option?: string
) => MountFullOptionsActionMessage = action(
    'mountFullOptions',
    (category?: string, subcategory?: string, option?: string): MountFullOptionsActionMessage => ({
        category,
        subcategory,
        option,
    })
);
